module.exports = __webpack_public_path__ + "arens.4a0c967403a90d84ad6e24f7c9bc72da.jpg";